import BaseEntity from './BaseEntity'

const Props = {
  id: undefined,
  comment: undefined,
  monthOfReview: undefined,
  coachRateAverage: undefined,
}

class Review extends BaseEntity {}

export default function createReview(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new Review(attr))
}
